import axios from 'axios';
import type { Dispatch } from 'redux';

const apiPath = '/api/';
export const noop = () => {};

export function getResource(
  actionType: string,
  resourceName: string,
  itemId: string | number,
  requestPath: string | undefined = undefined,
  onSuccess: () => void = noop,
  onFailure: () => void = noop,
): (dispatch: Dispatch<any>) => void {
  return (dispatch: Dispatch<any>) => {
    let path = `${apiPath}${resourceName}/${itemId}`;
    if (requestPath) {
      path = `${apiPath}${requestPath}`;
    }

    axios
      .get(path)
      .then(response => {
        dispatch({
          id: itemId,
          type: actionType,
          payload: response.data,
        });
      })
      .then(onSuccess)
      .catch(error => console.log(error))
      .then(onFailure);
  };
}

export function getResourceList(
  actionType: string,
  resourceName: string,
  requestPath: string | undefined = undefined,
  onSuccess: () => void = noop,
  onFailure: () => void = noop,
): (dispatch: Dispatch<any>) => void {
  return (dispatch: Dispatch<any>) => {
    let path = `${apiPath}${resourceName}/`;
    if (requestPath) {
      path = `${apiPath}${requestPath}`;
    }

    axios
      .get(path)
      .then(response => {
        dispatch({
          type: actionType,
          payload: response.data,
        });
      })
      .then(onSuccess)
      .catch(error => console.log(error))
      .then(onFailure);
  };
}

export function postResource(
  actionType: string,
  resourceName: string,
  requestPath: string | undefined = undefined,
  payload: unknown,
  onSuccess: () => void = noop,
  onFailure: () => void = noop,
): (dispatch: Dispatch<any>) => void {
  return (dispatch: Dispatch<any>) => {
    let path = `${apiPath}${resourceName}`;
    if (requestPath) {
      path = `${apiPath}${requestPath}`;
    }

    axios
      .post(path, payload)
      .then(response => {
        dispatch({
          type: actionType,
          payload: response.data,
        });
      })
      .then(onSuccess)
      .catch(error => console.log(error))
      .then(onFailure);
  };
}

export function patchResource(
  actionType: string,
  resourceName: string,
  requestPath: string | undefined = undefined,
  payload: unknown,
  onSuccess: () => void = noop,
  onFailure: () => void = noop,
): (dispatch: Dispatch<any>) => void {
  return (dispatch: Dispatch<any>) => {
    let path = `${apiPath}${resourceName}/`;
    if (requestPath) {
      path = `${apiPath}${requestPath}`;
    }

    axios
      .patch(path, payload)
      .then(response => {
        dispatch({
          type: actionType,
          payload: response.data,
        });
      })
      .then(onSuccess)
      .catch(error => console.log(error))
      .then(onFailure);
  };
}
